export const LOCALES = {
    ENGLISH: 'en-US',
    KHMER: 'km-KH'
}